import type { TUseRequestUpdaterProps } from 'features/request/useRequest';
import { useRequest } from 'features/request/useRequest';
import type { DismantlingCoefficientTypeEnum, UerRatioRowDefaultsQuery } from 'gql/graphql';
import { RatioTypeEnum } from 'gql/graphql';

import { useCallback, useMemo, useState } from 'react';
import type { UseFormSetValue } from 'react-hook-form/dist/types/form';

import { uerRatioRowDefaultsGql } from '../createOrEditRatioQueries';

interface IUseDefaultsForDismantlingRatio {
    ratioRowId: number | null;
    contractId: number;
    uerBaseRowId: number | null;
    isDismantlingRatio: boolean;
    setValue: UseFormSetValue<any>;
    groupType?: DismantlingCoefficientTypeEnum | null;
}

const requestId = 'useDefaultsForDismantlingRatio';

export const useDefaultsForDismantlingRatio = (props: IUseDefaultsForDismantlingRatio) => {
    const { contractId, uerBaseRowId, ratioRowId, isDismantlingRatio, setValue, groupType } = props;

    const [defaultGroupValue, setDefaultGroupValue] = useState<DismantlingCoefficientTypeEnum | null>();

    const variables = useMemo(
        () => ({
            contractId,
            ratioType: RatioTypeEnum.DismantlingCoef,
            uerBaseRowId,
        }),
        [contractId, uerBaseRowId],
    );

    const onSuccess = useCallback(
        (depsVars: TUseRequestUpdaterProps<UerRatioRowDefaultsQuery>) => {
            if (depsVars?.payload?.uerRatioRowDefaults?.data) {
                const item = depsVars?.payload?.uerRatioRowDefaults?.data;

                const { groupType: defaultGroupType } = item;

                if (defaultGroupType) {
                    setDefaultGroupValue(defaultGroupType);
                    setValue('groupType', defaultGroupType);
                }
            }
        },
        [setValue],
    );

    const [, , , , setRatioDefaultsDismantlingData] = useRequest({
        requestId,
        query: uerRatioRowDefaultsGql,
        variables,
        withEffect: Boolean(!ratioRowId && contractId && uerBaseRowId && isDismantlingRatio && !groupType),
        dependenciesUpdater: onSuccess,
    });

    return {
        defaultGroupType: defaultGroupValue,
        setRatioDefaultsDismantlingData,
    };
};
